import Fallback from './Fallback'
import ServerError from './ServerError'

export default {
  Fallback,
  ServerError,
}
